import React from "react";
import Icon from "../../Common/Icon";

const Unswitchable = ({ config: { className, text, reason } }) => {
  return (
    <div className={className}>
      <strong className="container--flex">
        <span>{text}</span>
        <span className="icon--checkmark-text">
          <Icon iconName="checkmark" />
          {reason}
        </span>
      </strong>
      <hr className="hr hr-switch" />
    </div>
  );
};
export default Unswitchable;



// WEBPACK FOOTER //
// ./src/components/FormTemplates/Content/Unswitchable.js